
define('template!adminUserGroupsCreatePopupView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="popup-header">\n  <div class="title">' +
((__t = ( _.i18n('common.create') )) == null ? '' : __t) +
'</div>\n</div>\n\n<div class="popup-body">\n  <div class="field">\n    <label class="field-label">' +
((__t = ( _.i18n('admin.userGroups.name') )) == null ? '' : __t) +
'</label>\n    <input type="text" class="name-input" />\n  </div>\n\n  <div class="field">\n    <label class="field-label">' +
((__t = ( _.i18n('admin.userGroups.addMember') )) == null ? '' : __t) +
'</label>\n    <div class="search-wrapper">\n      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>\n      <input type="text" class="search-input" placeholder="' +
((__t = ( placeholder )) == null ? '' : __t) +
'" />\n      <div class="suggestions" style="display: none;"></div>\n    </div>\n  </div>\n\n  <div class="field selected-field">\n    <label class="field-label">\n      ' +
((__t = ( _.i18n('admin.userGroups.members') )) == null ? '' : __t) +
'\n      <span class="count">' +
((__t = ( selected.length )) == null ? '' : __t) +
'</span>\n    </label>\n    <div class="selected-members">\n      ';
 if (selected.length === 0) { ;
__p += '\n        <div class="empty">' +
((__t = ( _.i18n('admin.userGroups.noMembers') )) == null ? '' : __t) +
'</div>\n      ';
 } else { ;
__p += '\n        ';
 _.each(selected, function (m) {
          var fn = m.firstName || '';
          var ln = m.lastName || '';
          var initials = ((fn.charAt(0) || '') + (ln.charAt(0) || '')).toUpperCase() || '?';
        ;
__p += '\n          <div class="selected-member">\n            <div class="avatar">' +
((__t = ( _.escape(initials) )) == null ? '' : __t) +
'</div>\n            <div class="info">\n              <div class="name">' +
((__t = ( _.escape((fn + ' ' + ln).trim() || '-') )) == null ? '' : __t) +
'</div>\n              ';
 if (m.email) { ;
__p += '\n                <div class="email">' +
((__t = ( _.escape(m.email) )) == null ? '' : __t) +
'</div>\n              ';
 } ;
__p += '\n            </div>\n            <button class="remove" data-sec-id="' +
((__t = ( _.escape(m.secId) )) == null ? '' : __t) +
'" title="' +
((__t = ( _.i18n('common.remove') )) == null ? '' : __t) +
'">\n              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>\n            </button>\n          </div>\n        ';
 }); ;
__p += '\n      ';
 } ;
__p += '\n    </div>\n  </div>\n</div>\n\n<div class="popup-footer">\n  <button class="btn btn-cancel">' +
((__t = ( _.i18n('common.cancel') )) == null ? '' : __t) +
'</button>\n  <button class="btn btn-confirm">' +
((__t = ( _.i18n('common.save') )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};});

